import httpClient from 'utils/httpClient';
const path = '/recruitment-apply';

export const getList = (params = {}) => {
  return httpClient.get(path, { params });
};

export const getDetail = (id) => {
  return httpClient.get(`${path}/${id}`);
};
export const create = (params) => {
  const headers = { 'Content-Type': 'multipart/form-data' };
  return httpClient.post(path, params, { headers });
};

export const update = (params) => {
  const headers = { 'Content-Type': 'multipart/form-data' };
  return httpClient.put(path, params, { headers });
};

export const deleteList = (list_id) => {
  return httpClient.delete(path, { data: { list_id } });
};

